import moment from 'moment';

export const getTimeDifferenceBetweenDatesByGivenUnitOfTime = (dateA, dateB, unitOfTime = 'ms') => (
    `${moment(dateA).diff(dateB, unitOfTime)} ${unitOfTime}`
);

export const getTimeDifferenceInMinutes = (dateA, dateB) => (
    moment.duration(moment(dateA).diff(moment(dateB))).asMinutes()
);

export const getTimeDifferenceInMinutesWithOneDecimal = (dateA, dateB) => (
    parseFloat(getTimeDifferenceInMinutes(dateA, dateB)?.toFixed(1))
);
export const convertMillisecondsToSeconds = (milliseconds) => (moment.duration(milliseconds).asSeconds());

export const convertMinutesToSeconds = (minutes) => (parseFloat(minutes) * 60);
export const convertSecondsToMinutes = (seconds) => (Math.round(parseFloat(seconds) / 60));
export const convertSecondsToMinutesFloat = (seconds) => seconds / 60;
export const convertSecondsToMinutesWithOneDecimal = (seconds) => (
    parseFloat((parseFloat(seconds) / 60)?.toFixed(1))
);

export const convertMillisecondsToMinutesAndSeconds = (milliseconds) => {
    const minutes = Math.floor(milliseconds.asMinutes());
    const seconds = Math.floor(milliseconds.asSeconds()) - minutes * 60;

    return `${minutes}m ${seconds}s`;
};

export const convertMillisecondsToHoursMinutesAndSeconds = (milliseconds) => {
    const hours = Math.floor(milliseconds.asHours());
    const minutes = Math.floor(milliseconds.asMinutes()) - (hours * 60);
    const seconds = Math.floor(milliseconds.asSeconds()) - (hours * 3600 + minutes * 60);

    return `${hours}h ${minutes}m ${seconds}s`;
};

export const subtractMinutesFromDate = (date, minutes) => (
    moment(date, 'YYYY-MM-DD HH:mm:ss').subtract(minutes, 'minutes').format('YYYY-MM-DD HH:mm:ss')
);
export const addMinutesToDate = (date, minutes) => (
    moment(date, 'YYYY-MM-DD HH:mm:ss').add(minutes, 'minutes').format('YYYY-MM-DD HH:mm:ss')
);
